/* eslint-disable indent */
import React from "react";
import { Grid, Paper, Radio } from "@material-ui/core";
import propTypes from "prop-types";
import clsx from "clsx";

import LogoCarssa from "../../logos/carssa.png";
// import LogoDHL from "../../logos/dhl.png";
import LogoDHLExpress from "../../logos/dhl-express.png";
import LogoDHLGround from "../../logos/dhl-ground.png";
import LogoDostavista from "../../logos/dostavista.png";
import LogoEstafeta from "../../logos/estafeta.png";
import LogoFedex from "../../logos/fedex.png";
import LogoIVoy from "../../logos/ivoy.png";
import Logo99Minutos from "../../logos/noventa9minutos.png";
import LogoPaquetexpress from "../../logos/paquetexpress.png";
import LogoQuiken from "../../logos/quiken.png";
import LogoRedpack from "../../logos/redpack.png";
import LogoSendex from "../../logos/sendex.png";
import LogoUPS from "../../logos/ups.png";
import LogoVencedor from "../../logos/vencedor.png";

// import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
// import RadioButtonCheckedIcon from "@material-ui/icons/RadioButtonChecked";

import useStyles from "./stylesCarrierOption";

const getLogo = (carrier = "", service = null) => {
  if (carrier === "dhl") {
    if (service === "ground") {
      return LogoDHLGround;
    } else {
      return LogoDHLExpress;
    }
  }
  switch (carrier) {
    case "carssa":
      return LogoCarssa;
    case "dostavista":
      return LogoDostavista;
    case "estafeta":
      return LogoEstafeta;
    case "fedex":
      return LogoFedex;
    case "ivoy":
      return LogoIVoy;
    case "noventa9Minutos":
      return Logo99Minutos;
    case "paquetexpress":
      return LogoPaquetexpress;
    case "quiken":
      return LogoQuiken;
    case "redpack":
      return LogoRedpack;
    case "sendex":
      return LogoSendex;
    case "ups":
      return LogoUPS;
    case "vencedor":
      return LogoVencedor;
    default:
      return;
  }
};

const OpcionCarrier = ({
  nombre,
  medio,
  tiempo,
  precio,
  option,
  checked,
  optionHandler
}) => {
  const classes = useStyles();

  const fixedPaperHeight = clsx(classes.paper, classes.opcionCarrier);

  return (
    <>
      <Paper className={fixedPaperHeight}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={1}>
            <Radio
              checked={checked}
              onChange={() => optionHandler(option)}
              value="a"
              name="radio-button-demo"
              inputProps={{ "aria-label": "A" }}
            />
          </Grid>
          <Grid item xs={3}>
            {<img src={getLogo(nombre, medio)} alt={nombre} />}
          </Grid>
          <Grid item xs={3}>
            {medio}
          </Grid>
          <Grid item xs={3}>
            {tiempo}
          </Grid>
          <Grid item xs={2}>
            ${Math.round(precio * 100) / 100}
          </Grid>
        </Grid>
      </Paper>
    </>
  );
};

OpcionCarrier.propTypes = {
  nombre: propTypes.string,
  medio: propTypes.string,
  tiempo: propTypes.string,
  precio: propTypes.number,
  option: propTypes.object,
  checked: propTypes.bool,
  optionHandler: propTypes.func
};

export default OpcionCarrier;
